import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DataGrid from "react-data-grid";
import { supabase } from "../client/client";
import "react-data-grid/lib/styles.css";

const FetchPasswordChanges = () => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [filters, setFilters] = useState({
        attendant: "",
        title: "",
        date_change: "",
        date_next_change: "",
    });

    const handleFilterChange = (filterName, value) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            [filterName]: value,
        }));
    };

    const columnsPasswordChanges = [
        { field: "attendant", name: "Encargado", width: 250, key: "attendant" },
        {
            field: "title",
            name: "Equipo",
            width: 250,
            key: "title",
            renderCell: ({ row }) => (
                <Link to={`/informacion/${row.id_equipo}`} underline="always">
                    {row.title}
                </Link>
            ),
        },
        { field: "date_change",      name: "Fecha de cambio",    width: 220, key: "date_change" },
        { field: "date_next_change", name: "Próximo cambio",      width: 220, key: "date_next_change" },
        { field: "frequency",        name: "Frecuencia",          width: 200, key: "frequency" },
    ];

    const gridStyle = { minHeight: "500px" };

    const fetchData = async () => {
        try {
            const { data: pwData, error: pwError } = await supabase
                .from("password_changes")
                .select("*");
            if (pwError) throw pwError;

            const validIds = [...new Set(pwData.map((r) => r.id_equipo).filter(Boolean))];
            let equiposData = [];
            if (validIds.length > 0) {
                const { data: eq, error: eqError } = await supabase
                    .from("equipos")
                    .select("id, title, attendant")
                    .in("id", validIds);
                if (eqError) throw eqError;
                equiposData = eq;
            }

            const combined = pwData.map((item) => {
                const equipo = equiposData.find((e) => e.id === item.id_equipo);
                return {
                    ...item,
                    title:     equipo?.title     ?? (item.equipo_title     || "(equipo eliminado)"),
                    attendant: equipo?.attendant ?? (item.equipo_attendant || ""),
                };
            });

            setData(combined);
        } catch (error) {
            console.error("Error fetching password changes:", error.message);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        const normalized = (v) => String(v ?? "").toLowerCase();
        const result = data
            .filter((row) =>
                Object.entries(filters).every(([key, value]) =>
                    normalized(row[key]).includes(normalized(value))
                )
            )
            .sort((a, b) => new Date(b.date_change) - new Date(a.date_change));
        setFilteredData(result);
    }, [filters, data]);

    return (
        <>
            <div className="flex items-center gap-2 mb-4 mt-5">
                <input
                    type="text"
                    placeholder="Filtrar por encargado"
                    value={filters.attendant}
                    onChange={(e) => handleFilterChange("attendant", e.target.value)}
                />
                <input
                    type="text"
                    placeholder="Filtrar por equipo"
                    value={filters.title}
                    onChange={(e) => handleFilterChange("title", e.target.value)}
                />
                <input
                    type="text"
                    placeholder="Filtrar por fecha de cambio"
                    value={filters.date_change}
                    onChange={(e) => handleFilterChange("date_change", e.target.value)}
                />
                <input
                    type="text"
                    placeholder="Filtrar por próximo cambio"
                    value={filters.date_next_change}
                    onChange={(e) => handleFilterChange("date_next_change", e.target.value)}
                />
            </div>
            <DataGrid
                rows={filteredData}
                columns={columnsPasswordChanges}
                style={gridStyle}
                rowHeight={50}
                minHeight={400}
                className="rdg-light"
            />
        </>
    );
};

export default FetchPasswordChanges;
